<template>
  <b-container fluid>
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Loading..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-form @submit.stop.prevent="onSubmit" v-else>
      <div class="row ml-0">
        <h5 class="mt-3">Информация о компании</h5>
      </div>
      <b-row>
        <b-col sm="3">
          <b-form-group
            label="ОПФ *"
            label-for="opf"
            label-class="mf-label"
            :invalid-feedback="getError('opf')"
            :state="validateState('opf')"
          >
            <treeselect id="opf"
                        name="opf"
                        :options="optionsOpf"
                        v-model="model.opf"
                        placeholder="Выбрать..."
                        noResultsText="Ничего не найдено..."
                        :clearable=false
                        v-validate="{ required: true }"
                        :state="validateState('opf')"
                        data-vv-as="ОПФ"
            >
              <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
            </treeselect>
          </b-form-group>
        </b-col>
        <b-col sm="7">
          <b-form-group
            label="Наименование *"
            label-for="organization-name"
            label-class="mf-label"
            :invalid-feedback="getError('organization-name')"
            :state="validateState('organization-name')"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-user"></i></b-input-group-text>
              <b-form-input
                id="organization-name"
                name="organization-name"
                v-validate="modelValidations.full_name"
                data-vv-as="Наименование"
                v-model="model.name"
                placeholder="Наименование без ОПФ"
                :state="validateState('organization-name')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5">
          <b-form-group
            label="ИНН *"
            label-for="inn-input"
            label-class="mf-label"
            :invalid-feedback="getError('inn-input')"
            :state="validateState('inn-input')"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-file-contract"></i></b-input-group-text>
              <b-form-input
                id="inn-input"
                name="inn-input"
                v-validate="modelValidations.inn"
                v-model="model.inn"
                data-vv-as="ИНН"
                placeholder="12 цифр"
                :state="validateState('inn-input')"
              ></b-form-input>
            </b-input-group>

          </b-form-group>
        </b-col>
        <b-col sm="5">
          <b-form-group
            label="КПП*"
            label-for="kpp-input"
            label-class="mf-label"
            :invalid-feedback="getError('kpp-input')"
            :state="validateState('kpp-input')"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-file-contract"></i></b-input-group-text>
              <b-form-input
                id="kpp-input"
                name="kpp-input"
                data-vv-as="КПП"
                v-validate="modelValidations.kpp"
                v-model="model.kpp"
                :placeholder="'9 цифр'"
                :state="validateState('kpp-input')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="ml-0">
        <h5 class="mt-3">Контактная информация</h5>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Контактное лицо"
            label-for="contact-person-input"
            label-class="mf-label"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-user"></i></b-input-group-text>
              <b-form-input
                id="contact-person-input"
                name="contact-person-input"
                v-model="model.p_contact_person"
                placeholder="Контактное лицо"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Город"
            label-for="city"
            label-class="mf-label"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-city"></i></b-input-group-text>
              <b-form-input id="city"
                            name="city"
                            v-model="model.city">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="row">
        <b-col sm="6">
          <b-form-group
            label="Фактический адрес"
            label-for="address"
            label-class="mf-label"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-map-marked-alt"></i>
              </b-input-group-text>
              <b-form-textarea
                id="address"
                name="address"
                v-model="model.real_address"
                placeholder="Фактический адрес"
              ></b-form-textarea>
            </b-input-group>

          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Email"
            label-for="email"
            label-class="mf-label"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-at"></i></b-input-group-text>
              <b-form-input id="email"
                            name="email"
                            v-model="model.email">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </div>
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Телефоны"
            label-for="contact-phones-input"
            label-class="mf-label"
          >
            <b-input-group class="mt-1">
              <b-input-group-text slot="prepend"><i class="fas fa-phone"></i></b-input-group-text>
              <b-form-textarea
                id="phones"
                name="telephone"
                v-model="model.phones">
              </b-form-textarea>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="12" class="mt-5">
          <b-button type="submit" :disabled="veeErrors.any()" variant="success">Редактировать</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'CompanyProfile',
  components: {
    Treeselect
  },
  data () {
    return {
      loading: null,
      model: {
        opf: '',
        name: '',
        inn: '',
        kpp: '',
        contact_person: '',
        city: '',
        email: '',
        real_address: '',
        phones: ''
      },
      optionsOpf: [],
      modelValidations: {
        opf: {
          required: true
        },
        full_name: {
          required: true
        },
        inn: {
          required: true,
          numeric: true,
          min: 10,
          max: 12
        },
        kpp: {
          required: true,
          digits: 9
        }
      }
    }
  },
  watch: {
    companyProfile () {
      this.model.name = this.companyProfile.name
      this.model.inn = this.companyProfile.inn
      this.model.kpp = this.companyProfile.kpp
      this.model.opf = this.companyProfile.opf_id
      this.model.contact_person = this.companyProfile.company_profile.contact_person
      this.model.city = this.companyProfile.company_profile.city
      this.model.email = this.companyProfile.company_profile.email
      this.model.real_address = this.companyProfile.company_profile.real_address
      this.model.phones = this.companyProfile.company_profile.phones
      this.loading = true
    },
    opfValue () {
      this.optionsOpf = this.opfValue
    }
  },
  mounted () {
    this.$store.dispatch('showUserInfo').then(
      () => {
        this.getCompanyData()
        this.loadOpfValue()
      }
    )
  },
  computed: {
    ...mapState(
      {
        opfValue: state => state.addCompanyData.opfValue,
        companyProfile: state => state.addCompanyData.companyProfile
      }
    )
  },
  methods: {
    getError (ref) {
      return this.veeErrors.first(ref)
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        const companyProfile = {
          inn: this.model.inn,
          kpp: this.model.kpp,
          name: this.model.name,
          opf_id: this.model.opf,
          company_profile: {
            city: this.model.city,
            contact_person: this.model.contact_person,
            email: this.model.email,
            phones: this.model.phones,
            real_address: this.model.real_address
          }
        }
        this.editCompanyData(companyProfile)
          .then(response => {
            console.log(response)
            this.$bvModal.msgBoxOk('Ваши данные успешно изменены!', {
              title: 'Данные изменены',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
          })
          .catch(() => {
            this.$bvModal.msgBoxOk('Что-то пошло не так!', {
              title: 'Что-то пошло не так',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
          })
      })
    },
    ...mapActions('addCompanyData',
      [
        'getCompanyData',
        'loadOpfValue',
        'editCompanyData'
      ]
    )
  }
}
</script>

<style scoped>
  h4 {
    margin-top: 0;
  }

  label {
    margin-bottom: 0;
    font-size: 14px;
    color: #37474F;
    line-height: 16px;
  }

  i {
    font-size: 14px;
  }
</style>
